import {
  Grow,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import { getTableColumns, convertedColumnName } from "../../common";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import moment from "moment";
import ls from "local-storage";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getPlannedMaintenanceListMultiple,
  downloadExcelFile,
  getList,
  getStatusList,
  getAreaList,
  getTechnicianList,
  getCostCenterList,
  getMaintenanceTypeList,
} from "../../store/actions/PlannedMaintenanceListActions";
import { getEquipmentReportList } from "../../store/actions/EquipmentAction";
import { getShifts } from "../../store/actions/ShiftActions";

import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarColumnsButton,
} from "@mui/x-data-grid";

import DetailFilter from "../../components/DetailFilter/DetailFilter";
import { StyledTableDiv } from "../../components/StyledComponents/StyledComponents";
import FilterButton from "../../components/FilterButton/FilterButton";
import FilterDrawer from "../../components/FilterDrawer/FilterDrawer";

//set current date
const setCurrentDate = (date) => {
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var modifiedMonth = month <= 9 ? "0" + month : month;
  var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  var newStartDate = year + "-" + modifiedMonth + "-" + day;
  return newStartDate;
};

const GetFirstDayOfMonth = () => {
  var dt = new Date(); // current date of week
  return new Date(dt.getFullYear(), dt.getMonth(), 1);
};

const GetLastDayOfMonth = () => {
  var curr = new Date(); // get current date
  return new Date(curr.getFullYear(), curr.getMonth() + 1, 0);
};

const GetFirstDayOfWeek = (date) => {
  var day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return moment(date.setDate(diff));
};

const GetLastDayOfWeek = (date) => {
  var day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
  return moment(date.setDate(diff + 6));
};

const ss = sessionStorage;

function PlannedMaintenanceTaskListTable(props) {
  const PlannedMaintenanceList = useSelector(
    (pmlState) => pmlState.PlannedMaintenanceList
  );
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");
  const { shiftList } = useSelector(({ Shifts }) => Shifts);

  const initialState = {
    checkedMe: false,
    poolIds: ls.get("pmlt_poolId") || [],
    shiftIds: ls.get("pmlt_shiftNo") || [],
    status: ls.get("pmlt_status") || [1, 2],
    user: parseInt(ss.getItem("pmlt_user")) || null,
    userName: ss.getItem("pmlt_userName") || null,
    creatorName: ss.getItem("pmlt_creatorName") || null,
    taskId: parseInt(ss.getItem("pmlt_taskID")) || 0,
    maintenanceNote: ss.getItem("pmlt_workingNote") || null,
    planNote: ss.getItem("pmlt_maintenanceNote") || null,
    areaGroupCode: ss.getItem("pmlt_areaGroupCode") || null,
    startDate: ls.get("pmlt_startDate") || GetFirstDayOfMonth().toISOString(),
    endDate: ls.get("pmlt_endDate") || GetLastDayOfMonth().toISOString(),
    selectedCostCenter: JSON.parse(ss.getItem("pmlt_selectedCostCenter")) || [],
    selectedMaintenanceOrderId:
      ss.getItem("pmlt_selectedMaintenanceOrderId") || null,
    selectedAreaFilter: sessionStorage.getItem("pmlt_selectedAreaGroupIds")
      ? JSON.parse(sessionStorage.getItem("pmlt_selectedAreaGroupIds"))
      : [],
    selectedCostCenterId: ss.getItem("pmlt_selectedCostCenterId")
      ? JSON.parse(ss.getItem("pmlt_selectedCostCenterId"))
      : [],
    selectedEquipmentGroup:
      JSON.parse(sessionStorage.getItem("pmlt_selectedEquipmentGroup")) || [],
    selectedMaintenanceType:
      JSON.parse(sessionStorage.getItem("pmlt_selectedMaintenanceType")) || [],
    includeOnlyLateTasks:
      JSON.parse(sessionStorage.getItem("pmlt_includeOnlyLateTasks")) || false,
    hasOrderPlaced: ss.getItem("pmlt_hasOrderPlaced") || null,
  };

  // States
  const [state, setState] = useState({ ...initialState });
  const [excelFilterState, setExcelFilterState] = useState({});
  const [rows, setRows] = useState([]);
  const [rowsLength, setRowsLength] = useState(0);
  const [poolData, setPoolData] = useState([]);
  const [statusData, setStatusData] = useState([]);
  let [selectedStatusName, setSelectedStatusName] = useState([]);
  let [timeIntervals, setTimeIntervals] = useState([
    { id: 1, name: t("Today") },
    { id: 2, name: t("ThisWeek") },
    { id: 3, name: t("ThisMonth") },
    { id: 4, name: t("Manual") },
  ]);
  let [selectedTimeInterval, setSelectedTimeInterval] = useState(
    ls.get("pmlt_interval") || 3
  );

  // Pagination
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const HandleChangePage = (event, newPage) => {
    setCurrentPage(event);
    loadDataHandler(event);
  };

  const HandleChangeRowsPerPage = (event) => {
    setRowsPerPage(event);
    ss.setItem("pmlt_rowsPerPage", event);
    setCurrentPage(0);
    loadDataHandler(0, event);
  };

  useEffect(() => {
    if (PlannedMaintenanceList.taskListMultiple?.firstCallRes) {
      if (state.status.length === 0) {
        setRows([]);
      }
      setRows(
        Object.values(
          PlannedMaintenanceList.taskListMultiple.firstCallRes.resultObject
            .content
        )
      );
      setRowsLength(
        PlannedMaintenanceList.taskListMultiple.firstCallRes.resultObject
          .totalCount
      );
    }
  }, [PlannedMaintenanceList.taskListMultiple]);

  useEffect(() => {
    if (PlannedMaintenanceList.poolList?.length) {
      setPoolData(Object.values(PlannedMaintenanceList.poolList));
    }
  }, [PlannedMaintenanceList.poolList]);

  useEffect(() => {
    if (PlannedMaintenanceList.statusList) {
      setStatusData(Object.values(PlannedMaintenanceList.statusList));
      HandleStatusName(
        Object.values(PlannedMaintenanceList.statusList),
        state.status
      );
    }
  }, [PlannedMaintenanceList.statusList]);

  useEffect(() => {
    if (PlannedMaintenanceList.areaList) {
      let areaList = PlannedMaintenanceList.areaList;
      setAreaData(areaList);
    }
  }, [PlannedMaintenanceList.areaList]);

  useEffect(() => {
    if (PlannedMaintenanceList.technicianList) {
      setUserData(Object.values(PlannedMaintenanceList.technicianList));
    }
  }, [PlannedMaintenanceList.technicianList]);

  useEffect(() => {
    if (PlannedMaintenanceList.costCenterList) {
      LoadAreaData();
      setCostCenterData(Object.values(PlannedMaintenanceList.costCenterList));
      setFilterOpen(true);
    }
  }, [PlannedMaintenanceList.costCenterList]);

  let [maintenanceTypeData, setMaintenanceTypeData] = useState([]);

  useEffect(() => {
    if (PlannedMaintenanceList.maintenanceTypeList) {
      setMaintenanceTypeData(PlannedMaintenanceList.maintenanceTypeList);
    }
  }, [PlannedMaintenanceList.maintenanceTypeList]);

  //load shift data
  let [shiftData, setShiftData] = useState([]);
  useEffect(() => {
    if (shiftList?.resultObject?.length > 0) {
      setShiftData(shiftList.resultObject[0].shifts);
    }
  }, [shiftList]);

  useEffect(() => {
    dispatch(getStatusList());
    dispatch(getList());
    dispatch(getTechnicianList());
    dispatch(getCostCenterList());
    dispatch(getShifts());
    componentDidMount();
    LoadHandler();
  }, []);

  const HandleTimeInterval = (e) => {
    setSelectedTimeInterval(e.target.value);
    ls.set("pmlt_interval", e.target.value);
    HandleTimeSelection(e.target.value);
    loadDataHandler(0, rowsPerPage);
  };

  const SetDates = (start, end) => {
    setState((prevState) => ({
      ...prevState,
      startDate: start,
      endDate: end,
    }));
    ls.set("pmlt_startDate", start);
    ls.set("pmlt_endDate", end);
  };

  const HandleTimeSelection = (id) => {
    switch (id) {
      case 1: //gün
        SetDates(setCurrentDate(new Date()), setCurrentDate(new Date()));
        break;
      case 2: //hafta
        SetDates(GetFirstDayOfWeek(new Date()), GetLastDayOfWeek(new Date()));
        break;
      case 3: //ay
        SetDates(GetFirstDayOfMonth(), GetLastDayOfMonth());
        break;
      default:
        SetDates(setCurrentDate(new Date()), setCurrentDate(new Date()));
        break;
    }
  };

  const setDefaultState = () => {
    setState({
      checkedMe: false,
      poolIds: ls.get("pmlt_poolId") || [],
      shiftIds: ls.get("pmlt_shiftNo") || [],
      status: ls.get("pmlt_status") || [1, 2],
      user: null,
      userName: null,
      creatorName: "",
      taskId: 0,
      maintenanceNote: null,
      planNote: null,
      areaGroupCode: null,
      startDate: ls.get("pmlt_startDate") || setCurrentDate(new Date()),
      endDate: ls.get("pmlt_endDate") || setCurrentDate(new Date()),
      selectedCostCenter: [],
      selectedMaintenanceOrderId: null,
      selectedAreaFilter: [],
      selectedCostCenterId: ss.getItem("pmlt_selectedCostCenterId")
        ? JSON.parse(ss.getItem("pmlt_selectedCostCenterId"))
        : [],
      selectedEquipmentGroup: [],
      selectedMaintenanceType: [],
      includeOnlyLateTasks: false,
      hasOrderPlaced: null,
    });
  };

  const componentDidMount = () => {
    setState({ ...initialState });
  };

  function LoadHandler() {
    dispatch(getEquipmentReportList());
    dispatch(getMaintenanceTypeList());
    let lastRowsPerPage = rowsPerPage;
    if (ss.getItem("pmlt_rowsPerPage")) {
      lastRowsPerPage = parseInt(ss.getItem("pmlt_rowsPerPage"));
      setRowsPerPage(lastRowsPerPage);
    }
    if (ss.getItem("pmlt_pushPlannedDetail")) {
      setCurrentPage(parseInt(ss.getItem("pmlt_pushPlannedDetail")));
      loadDataHandler(
        parseInt(ss.getItem("pmlt_pushPlannedDetail")),
        lastRowsPerPage
      );
      ss.removeItem("pmlt_pushPlannedDetail");
    } else {
      loadDataHandler(0, lastRowsPerPage);
    }
  }

  // Load data handler
  const loadDataHandler = (
    pageNumber = currentPage,
    pageSize = rowsPerPage,
    isFilterCleared = false
  ) => {
    const machineId = isFilterCleared
      ? 0
      : machineStates.selectedSubEquipmentCode ??
        machineStates.selectedMainEquipmentCode ??
        0;

    const data = {
      statusArr: ls.get("pmlt_status")
        ? ls.get("pmlt_status").toString()
        : [1, 2].toString(),
      poolIds: ls.get("pmlt_poolId") || [],
      assigneedIds: ss.getItem("pmlt_user")
        ? [parseInt(ss.getItem("pmlt_user"))]
        : [],
      creatorIds: ss.getItem("pmlt_creatorCode")
        ? [parseInt(ss.getItem("pmlt_creatorCode"))]
        : [],
      costCenterIds: ss.getItem("pmlt_selectedCostCenterId")
        ? JSON.parse(ss.getItem("pmlt_selectedCostCenterId"))
        : [],
      areaGroupIds: ss.getItem("pmlt_selectedAreaGroupIds")
        ? JSON.parse(ss.getItem("pmlt_selectedAreaGroupIds"))
        : [],
      taskId: ss.getItem("pmlt_taskID")
        ? parseInt(ss.getItem("pmlt_taskID"))
        : 0,
      orderId: ss.getItem("pmlt_selectedMaintenanceOrderId")
        ? parseInt(ss.getItem("pmlt_selectedMaintenanceOrderId"))
        : 0,
      taskNote: ss.getItem("pmlt_workingNote")
        ? ss.getItem("pmlt_workingNote")
        : null,
      orderNote: ss.getItem("pmlt_maintenanceNote")
        ? ss.getItem("pmlt_maintenanceNote")
        : null,
      machineId: machineId,
      startDate: ls.get("pmlt_startDate")
        ? ls.get("pmlt_startDate")
        : GetFirstDayOfMonth().toISOString(),
      endDate: ls.get("pmlt_endDate")
        ? ls.get("pmlt_endDate")
        : GetLastDayOfMonth().toISOString(),
      isEnvNotClean: JSON.parse(ss.getItem("pmlt_isEnvNotClean")),
      shifts: ls.get("pmlt_shiftNo") || [],
      equipmentReportGroupIds: ss.getItem("pmlt_selectedEquipmentGroup")
        ? JSON.parse(ss.getItem("pmlt_selectedEquipmentGroup"))
        : [],
      maintenanceTypeIds: ss.getItem("pmlt_selectedMaintenanceType")
        ? JSON.parse(ss.getItem("pmlt_selectedMaintenanceType"))
        : [],
      fetchOnlyLateTasks: ss.getItem("pmlt_includeOnlyLateTasks")
        ? JSON.parse(ss.getItem("pmlt_includeOnlyLateTasks"))
        : false,
      hasOrderPlaced: JSON.parse(ss.getItem("pmlt_hasOrderPlaced")) || null,
    };
    setExcelFilterState(data);

    let payload = {
      pageSize: pageSize,
      currentPage: pageNumber + 1,
      data: data,
      firstCall: true,
    };

    dispatch(getPlannedMaintenanceListMultiple(payload));
  };

  // Set status
  const HandleStatus = (event) => {
    setState({ ...state, status: event.target.value });
    HandleStatusName(statusData, event.target.value);
    ls.set("pmlt_status", event.target.value);
  };

  // Set status name
  const HandleStatusName = (rawArray, filterArray) => {
    const statusFiltered = rawArray.filter((el) => {
      return filterArray.some((f) => {
        return f === el.code;
      });
    });
    setSelectedStatusName(statusFiltered.map((item) => item.description));
  };

  // Set pool
  const HandlePool = (poolName) => {
    let ids = [];
    poolName.map((item) => ids.push(item.id));
    setState({ ...state, poolIds: ids });
    ls.set("pmlt_poolId", ids);
  };

  const HandleShift = (shiftNo) => {
    let shiftIds = [];
    if (shiftNo != null) {
      shiftNo.map((item) => shiftIds.push(item.shiftNo));
      setState({ ...state, shiftIds: shiftIds });
      ls.set("pmlt_shiftNo", shiftIds);
    }
  };

  // Set user
  const HandleUser = (userName) => {
    const userInfo = userData.filter((item) => item.userName == userName);
    let userId = null;

    if (userInfo[0] != undefined) {
      // Filter if user exist
      userId = userInfo[0].id;
    }
    if (userName == null) {
      ss.removeItem("pmlt_userName");
      ss.removeItem("pmlt_user");
    } else {
      ss.setItem("pmlt_userName", userName);
      ss.setItem("pmlt_user", userId);
    }

    setState({ ...state, checkedMe: false, user: userId, userName: userName });
  };

  // Set start date
  const HandleStartDate = (date) => {
    if (date == null) {
      ls.removeItem("pmlt_startDate");
    } else {
      ls.set("pmlt_startDate", moment(date).format("YYYY-MM-DD"));
    }

    ls.set("pmlt_interval", 4);
    setSelectedTimeInterval(4);
    setState({ ...state, startDate: date });
  };

  // Set end date
  const HandleEndDate = (date) => {
    if (date == null) {
      ls.removeItem("pmlt_endDate");
    } else {
      ls.set("pmlt_endDate", moment(date).format("YYYY-MM-DD"));
    }

    ls.set("pmlt_interval", 4);
    setSelectedTimeInterval(4);
    setState({ ...state, endDate: date });
  };

  // Detail popup
  const [filterOpen, setFilterOpen] = useState(false);

  const [userData, setUserData] = useState([]);
  const [costCenterData, setCostCenterData] = useState([]);

  const HandleApplyFilter = () => {
    loadDataHandler(0, rowsPerPage);
    setIsFilterDrawerOpen(false);
  };

  const FilterWithID = (e) => {
    if (e.target.value == null) {
      ss.removeItem("pmlt_taskID");
    } else {
      ss.setItem("pmlt_taskID", e.target.value);
    }

    setState({ ...state, taskId: e.target.value });
  };

  const FilterWithMaintenanceNote = (e) => {
    if (e.target.value == null) {
      ss.removeItem("pmlt_workingNote");
    } else {
      ss.setItem("pmlt_workingNote", e.target.value);
    }

    setState({ ...state, maintenanceNote: e.target.value });
  };

  const FilterWithPlanNote = (e) => {
    if (e.target.value == null) {
      ss.removeItem("pmlt_maintenanceNote");
    } else {
      ss.setItem("pmlt_maintenanceNote", e.target.value);
    }

    setState({ ...state, planNote: e.target.value });
  };

  const FilterOrderId = (e) => {
    if (e.target.value == null) {
      ss.removeItem("pmlt_selectedMaintenanceOrderId");
    } else {
      ss.setItem("pmlt_selectedMaintenanceOrderId", e.target.value);
    }

    setState({ ...state, selectedMaintenanceOrderId: e.target.value });
  };

  const HandleCostCenterChange = (costCenter) => {
    let ids = [];
    costCenter.map((item) => ids.push(item.id));
    if (costCenter == null) {
      ss.removeItem("pmlt_selectedCostCenterId");
    } else {
      ss.setItem("pmlt_selectedCostCenterId", JSON.stringify(ids));
    }
    setState({ ...state, selectedCostCenterId: ids });
  };

  // Set creator for filter
  const HandleCreatorName = (creatorName) => {
    const userInfo = userData.filter((item) => item.userName == creatorName);
    let creatorCode = null;

    if (userInfo[0] != undefined) {
      creatorCode = userInfo[0].id;
    }
    if (creatorName == null) {
      ss.removeItem("pmlt_creatorName");
      ss.removeItem("pmlt_creatorCode");
    } else {
      ss.setItem("pmlt_creatorName", creatorName);
      ss.setItem("pmlt_creatorCode", creatorCode);
    }

    setState({
      ...state,
      checkedMe: false,
      creatorName: creatorName,
      creatorCode: creatorCode,
    });
  };

  const HandleAreaFilterChange = (areaName) => {
    let areaGroupIds = [];
    areaName.map((item) => areaGroupIds.push(item.id));
    if (areaName == null) {
      sessionStorage.removeItem("pmlt_selectedAreaGroupIds");
    } else {
      sessionStorage.setItem(
        "pmlt_selectedAreaGroupIds",
        JSON.stringify(areaGroupIds)
      );
    }
    setState({ ...state, selectedAreaFilter: areaGroupIds });
  };

  const HandleMaintenanceType = (maintenanceType) => {
    let ids = [];
    maintenanceType.map((item) => ids.push(item.id));
    if (maintenanceType == null) {
      sessionStorage.removeItem("pmlt_selectedMaintenanceType");
    } else {
      sessionStorage.setItem(
        "pmlt_selectedMaintenanceType",
        JSON.stringify(ids)
      );
    }
    setState({ ...state, selectedMaintenanceType: ids });
  };

  const HandleEquipmentGroup = (equipmentGroup) => {
    let ids = [];
    equipmentGroup.map((item) => ids.push(item.value));
    if (equipmentGroup == null) {
      sessionStorage.removeItem("pmlt_selectedEquipmentGroup");
    } else {
      sessionStorage.setItem(
        "pmlt_selectedEquipmentGroup",
        JSON.stringify(ids)
      );
    }
    setState({ ...state, selectedEquipmentGroup: ids });
  };

  let [allGroup, setAllGroup] = useState([]);
  const { eqReportList } = useSelector(({ equipment }) => equipment);

  useEffect(() => {
    if (eqReportList?.resultObject) {
      setAllGroup(
        Object.values(eqReportList.resultObject).map((item, index) => ({
          label: item.name,
          value: item.id,
          name: item.name,
        }))
      );
    }
  }, [eqReportList]);

  const HandleLate = (includeOnlyLateTasks) => {
    if (includeOnlyLateTasks == null) {
      sessionStorage.removeItem("pmlt_includeOnlyLateTasks");
    } else {
      sessionStorage.setItem(
        "pmlt_includeOnlyLateTasks",
        JSON.stringify(includeOnlyLateTasks)
      );
    }
    setState({ ...state, includeOnlyLateTasks });
  };

  const HandleHasOrderPlaced = (e) => {
    if (e == null) {
      sessionStorage.removeItem("pmlt_hasOrderPlaced");
    } else {
      sessionStorage.setItem("pmlt_hasOrderPlaced", e);
    }
    setState({ ...state, hasOrderPlaced: e });
  };

  // Load area data for popup
  let [areaData, setAreaData] = useState([]);
  const LoadAreaData = () => {
    dispatch(getAreaList());
  };

  // Machine popup
  const initialMachineStates = (isCleared = false) => {
    return {
      ssAbr: "pmlt",
      selectedAreaCode: isCleared
        ? null
        : ss.getItem("pmlt_selectedAreaCode") ?? null,
      selectedAreaName: isCleared
        ? null
        : ss.getItem("pmlt_selectedAreaName") ?? null,
      selectedMainEquipmentCode: isCleared
        ? null
        : ss.getItem("pmlt_selectedMainEquipmentCode") ?? null,
      selectedMainEquipmentName: isCleared
        ? null
        : ss.getItem("pmlt_selectedMainEquipmentName") ?? null,
      selectedSubEquipmentCode: isCleared
        ? null
        : ss.getItem("pmlt_selectedSubEquipmentCode") ?? null,
      selectedSubEquipmentName: isCleared
        ? null
        : ss.getItem("pmlt_selectedSubEquipmentName") ?? null,
    };
  };
  const [machineStates, setMachineStates] = useState(initialMachineStates);
  const HandleClearMachineStates = () => {
    ss.removeItem("pmlt_selectedAreaCode");
    ss.removeItem("pmlt_selectedAreaName");
    ss.removeItem("pmlt_selectedMainEquipmentCode");
    ss.removeItem("pmlt_selectedMainEquipmentName");
    ss.removeItem("pmlt_selectedSubEquipmentCode");
    ss.removeItem("pmlt_selectedSubEquipmentName");
    setMachineStates(initialMachineStates(true));
  };

  const HandleClearFilter = () => {
    setSelectedTimeInterval(3);
    ls.set("pmlt_interval", 3);
    ls.set("pmlt_startDate", GetFirstDayOfMonth().toISOString());
    ls.set("pmlt_endDate", GetLastDayOfMonth().toISOString());
    ls.set("pmlt_status", []);
    ls.set("pmlt_poolId", []);
    ls.set("pmlt_shiftNo", []);

    HandleClearMachineStates();
    setIsEnvNotClean(null);
    handleClearSessionStorage();
    setDefaultState();
    loadDataHandler(0, rowsPerPage, true);
  };

  const handleClearSessionStorage = () => {
    ss.removeItem("pmlt_areaGroupCode");
    ss.removeItem("pmlt_maintenanceNote");
    ss.removeItem("pmlt_creatorName");
    ss.removeItem("pmlt_creatorCode");
    ss.removeItem("pmlt_workingNote");
    ss.removeItem("pmlt_taskID");
    ss.removeItem("pmlt_user");
    ss.removeItem("pmlt_userName");
    ss.removeItem("pmlt_selectedAreaFilter");
    ss.removeItem("pmlt_selectedAreaGroupIds");
    ss.removeItem("pmlt_selectedCostCenterId");
    ss.removeItem("pmlt_selectedMaintenanceOrderId");
    ss.removeItem("pmlt_isEnvNotClean");
    ss.removeItem("pmlt_selectedEquipmentGroup");
    ss.removeItem("pmlt_selectedMaintenanceType");
    ss.removeItem("pmlt_includeOnlyLateTasks", JSON.stringify(false));
    ss.removeItem("pmlt_hasOrderPlaced");
  };

  let history = useHistory();
  const NavigateToDetails = (id) => {
    ss.setItem("pmlt_pushPlannedDetail", currentPage);
    ss.setItem("pmlt_rowsPerPage", rowsPerPage);
    history.push("/planned-maintenance-detail?id=" + id);
  };

  const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);

  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setIsFilterDrawerOpen(open);
  };

  const filter = () => {
    return (
      <DetailFilter
        HandleStatus={HandleStatus}
        HandlePool={HandlePool}
        HandleUser={HandleUser}
        HandleAreaFilterChange={HandleAreaFilterChange}
        HandleCreatorName={HandleCreatorName}
        HandleCostCenterChange={HandleCostCenterChange}
        HandleMaintenanceType={HandleMaintenanceType}
        maintenanceTypeData={maintenanceTypeData}
        maintenanceType={state.selectedMaintenanceType}
        HandleLate={HandleLate}
        late={state.includeOnlyLateTasks}
        HandleEquipmentGroup={HandleEquipmentGroup}
        equipmentGroupData={allGroup}
        selectedEquipmentGroup={state.selectedEquipmentGroup}
        selectedStatusName={selectedStatusName}
        statusData={statusData}
        poolData={poolData}
        userData={userData}
        costCenterData={costCenterData}
        areaData={areaData}
        FilterWithID={FilterWithID}
        FilterPlanId={FilterOrderId}
        FilterWithMaintenanceNote={FilterWithMaintenanceNote}
        FilterWithPlanNote={FilterWithPlanNote}
        status={state.status}
        poolIds={state.poolIds}
        creatorName={state.creatorName}
        selectedCostCenterId={state.selectedCostCenterId}
        userName={state.userName}
        selectedAreaFilter={state.selectedAreaFilter}
        taskId={state.taskId}
        selectedPlanId={state.selectedMaintenanceOrderId}
        maintenanceNote={state.maintenanceNote}
        planNote={state.planNote}
        setMachineStates={setMachineStates}
        machineStates={machineStates}
        isAreaNotFiltered={true}
        isEnvNotClean={isEnvNotClean}
        handleEnvironmentalComplianceChange={
          handleEnvironmentalComplianceChange
        }
        HandleShift={HandleShift}
        shiftData={shiftData}
        shiftIds={state.shiftIds}
        HandleTimeInterval={HandleTimeInterval}
        selectedTimeInterval={selectedTimeInterval}
        timeIntervals={timeIntervals}
        startDate={state.startDate}
        endDate={state.endDate}
        HandleStartDate={HandleStartDate}
        HandleEndDate={HandleEndDate}
        HandleHasOrderPlaced={HandleHasOrderPlaced}
        hasOrderPlaced={state.hasOrderPlaced}
        isMultipleAreaGroup={true}
      />
    );
  };

  const [isEnvNotClean, setIsEnvNotClean] = useState(
    JSON.parse(ss.getItem("pmlt_isEnvNotClean"))
  );
  const handleEnvironmentalComplianceChange = (newValue) => {
    setIsEnvNotClean(newValue);
    ss.setItem("pmlt_isEnvNotClean", newValue);
  };

  const columnVisibilityModelData =
    JSON.parse(localStorage.getItem("columnVisibilityModel")) || {};
  const [columnVisibilityModel, setColumnVisibilityModel] = useState(
    columnVisibilityModelData
  );

  const handleChangeVisibility = (newModel) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem("columnVisibilityModel", JSON.stringify(newModel));
  };

  const customToolbar = () => {
    return (
      <GridToolbarContainer>
        <GridToolbarDensitySelector />
        <GridToolbarColumnsButton name="column" />
        {/* <GridToolbarFilterButton /> */}
      </GridToolbarContainer>
    );
  };

  const [sortModel, setSortModel] = useState(() => {
    const saved = localStorage.getItem("plannedMaintenanceTaskSort");
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    localStorage.setItem(
      "plannedMaintenanceTaskSort",
      JSON.stringify(sortModel)
    );
  }, [sortModel]);

  const onSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
    localStorage.setItem(
      "plannedMaintenanceTaskSort",
      JSON.stringify(newSortModel)
    );
  };

  return (
    <StyledTableDiv>
      <h1 id="pmlt_PageTitle">{t("PlannedMaintenanceTaskListTable")}</h1>
      <Grid id="pmlt_Grid" container justifyContent="center">
        <FilterDrawer
          open={isFilterDrawerOpen}
          onOpen={toggleDrawer(true)}
          onClose={toggleDrawer(false)}
          HandleClearFilter={HandleClearFilter}
          HandleApplyFilter={HandleApplyFilter}
          downloadExcel={() =>
            dispatch(
              downloadExcelFile({
                ...excelFilterState,
                startDate: excelFilterState.startDate ?? "2021-01-01",
                endDate: excelFilterState.endDate ?? "2023-01-01",
              })
            )
          }
          detailFilter={filter()}
        />
        <FilterButton onClick={() => toggleDrawer(true)} />
      </Grid>
      {rows.length > 0 ? (
        <Grow
          in={true}
          style={{ transformOrigin: "0 0 0" }}
          {...{ timeout: 1000 }}
        >
          <div style={{ width: "100%", textAlign: "center" }}>
            <DataGrid
              autoHeight={true}
              rows={rows}
              columns={getTableColumns(true, poolData, statusData)}
              pageSize={rowsPerPage}
              onPageSizeChange={HandleChangeRowsPerPage}
              onPageChange={HandleChangePage}
              rowsPerPageOptions={[5, 10, 20, 50]}
              rowCount={rowsLength} //total count
              page={currentPage}
              paginationMode="server"
              sortModel={sortModel}
              disableColumnFilter
              disableColumnMenu
              getRowId={(row) => row.id}
              onRowClick={(param) => {
                NavigateToDetails(param.id);
              }}
              components={{
                Toolbar: customToolbar,
              }}
              filterMode="server"
              // onFilterModelChange={(param) => {
              //     onFilterChange(param, 0, rowsPerPage);
              // }}
              columnVisibilityModel={columnVisibilityModel}
              onColumnVisibilityModelChange={(newModel) =>
                handleChangeVisibility(newModel)
              }
              onSortModelChange={onSortModelChange}
              sx={{
                boxShadow: 5,
                "& .MuiDataGrid-row:hover": {
                  color: "primary.main",
                },
                "& .MuiDataGrid-columnSeparator": {
                  display: "none",
                },
              }}
              localeText={{
                toolbarColumns: t("Columns"),
                columnsPanelTextFieldLabel: t("ColumnsPanelTextFieldLabel"),
                columnsPanelTextFieldPlaceholder: t(
                  "ColumnsPanelTextFieldPlaceholder"
                ),
                columnsPanelShowAllButton: t("ColumnsPanelShowAllButton"),
                columnsPanelHideAllButton: t("ColumnsPanelHideAllButton"),
                toolbarDensity: t("Density"),
                toolbarDensityCompact: t("DensityCompact"),
                toolbarDensityStandard: t("DensityStandard"),
                toolbarDensityComfortable: t("DensityComfortable"),
              }}
            />
          </div>
        </Grow>
      ) : null}

      <LoadingBackdrop id="pmlt_lbd" />
    </StyledTableDiv>
  );
}

export default withRouter(PlannedMaintenanceTaskListTable);
